import { getRequest } from '@/framework/utils/request';
const request = getRequest('common');

// 登录
export function login(data) {
  return request({
    //url: '/system/login/loginByAccount',
    url: '/portal/supplier/login',
    // url: process.env.VUE_APP_BASE_API + '/auth/jwtToken',
    method: 'post',
    data
  })
}

// 登出
export function logout(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/auth/logout',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/portal/user/info',
    method: 'get',
    params: { token }
  })
}



